import { DebugHelper } from "@/helper/debugHelper";

export class ZipDecompressor
{
    private unzip;

    constructor(buffer : ArrayBuffer)
    {
        var unzip = require('zlibjs/bin/unzip.min').Zlib.Unzip;
        this.unzip = new unzip(new Uint8Array(buffer));
    }

    public getFilenames() : Array<string> | null
    {
        var filenames : Array<string> | null = null;
        try
        {
            filenames = this.unzip.getFilenames();
        }
        catch(e)
        {
            DebugHelper.trace(e);
            filenames = null;
        }

        return filenames;
    }

    public decompressFile(filename : string) : Uint8Array | null
    {
        var decompressed : Uint8Array | null = null;
        try
        {
            decompressed = this.unzip.decompress(filename);
        }
        catch(e)
        {
            DebugHelper.trace(e);
            decompressed = null;
        }

        return decompressed;
    }

    public dispose()
    {
        this.unzip = null;
    }
}